// ##### Komarov 2025-07-23
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../hooks/useLocalizedText';

// ##### Komarov 2025-07-14
const ClickableLayer_01_ToursAutocompleteSmallScreenDivTag_Alert = ({
  width,
  height,
}) => {
  // ##### Komarov 2025-08-05
  const chooseYourDestination = useLocalizedText('ChooseYourDestination');
  return (
    <div
      data-component="ClickableLayer_01_ToursAutocompleteSmallScreenDivTag_Alert"
      id="clickableLayer_01_ToursAutocompleteSmallScreen_Alert"
      style={{
        gridColumn: '1',
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-around',
        width: width,
        height: height,
        border: 'red',
        borderStyle: 'solid',
        borderRadius: '1rem',
        fontFamily: 'Arial',
        alignItems: 'center',
        // ##### 23-04-26 Komarov
        margin: '0.3vw',
      }}
    >
      {/* ##### 23-03-30 Komarov */}
      <div
        style={{
          display: 'inline-flex',
          flexDirection: 'row',
          // marginTop: "0.25em",
          textAlign: 'center',
          lineHeight: 1,
          color: 'red',
        }}
      >
        {chooseYourDestination}
      </div>
    </div>
  );
};

export default ClickableLayer_01_ToursAutocompleteSmallScreenDivTag_Alert;
